// extracted by mini-css-extract-plugin
export default {"root":"u0qfpId8xbjtu9OlkZod","placeHolderShimmer":"zWJd0VT4QK14aYBSzOp1"};